var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"TempSave"},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.tempSaveBtn()}}},[_vm._v("暂存")]),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.clearTempData()}}},[_vm._v("清空")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }